jQuery(function($) {
    // add screen reader text for all links opening to a new tab
    $('a[target="_blank"]').each(function() {
        $(this).append('<span class="screen-reader-text"> ' + lucciLangStrings.opens_in_new_tab + '</span>')
    })
})